import { gsap } from 'gsap'

class Hamburger {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = this.dom.el;
    this.dom.menu = document.querySelector('[data-js="menu"]');
    this.dom.closer = document.querySelectorAll('[data-js="menu-closer"]');
    this.dom.menuItems = this.dom.menu.querySelectorAll('.g-menu-navigation-list');
    this.dom.body = document.querySelector('body');

    this.isOpen = false;
    this.isAnimating = false;

    this.toggleMenu = this.toggleMenu.bind(this);

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {
    this.dom.trigger.addEventListener('click', e => {
      this.toggleMenu();
    });
    [...this.dom.closer].forEach(el=>{
      el.addEventListener('click', e => {
        this.toggleMenu();
      });
    });

    // 初期状態をセット
    gsap.set(this.dom.menu, { opacity: 0, pointerEvents: 'none' });
    gsap.set(this.dom.menuItems, { opacity: 0, y: 24 });

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);
  }

  toggleMenu() {
    if (this.isAnimating) return;

    if (this.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.isAnimating = true;
    this.isOpen = true;

    this.dom.trigger.setAttribute('aria-expanded', true);
    this.dom.menu.setAttribute('aria-hidden', false);
    this.scrollDisable();
    document.body.dataset.menu = 'visible';

    const tl = gsap.timeline({
      onComplete: () => {
        this.isAnimating = false;
      }
    });

    tl.to(this.dom.menu, {
      opacity: 1,
      pointerEvents: 'auto',
      duration: .6,
      ease: 'power2.inOut',
    })
    .fromTo(this.dom.menuItems, {
      opacity: 0,
      y: '1rem',
    }, {
      opacity: 1,
      y: 0,
      duration: .45,
      ease: 'power3.out',
      stagger: .05,
    }, '-=.1');
  }

  closeMenu() {
    this.isAnimating = true;

    const tl = gsap.timeline({
      onComplete: () => {
        this.isOpen = false;
        this.isAnimating = false;
        this.dom.trigger.setAttribute('aria-expanded', false);
        this.dom.menu.setAttribute('aria-hidden', true);
        this.scrollEnable();
        document.body.removeAttribute('data-menu');
      }
    });

    tl.to(this.dom.menuItems, {
      opacity: 0,
      y: '-1rem',
      duration: .45,
      ease: 'power2.in',
      stagger: .01,
    })
    .to(this.dom.menu, {
      opacity: 0,
      pointerEvents: 'none',
      duration: .6,
      ease: 'power2.in',
    }, '-=.0');
  }

  resetMenu() {
    gsap.killTweensOf([this.dom.menu, this.dom.menuItems]);
    gsap.set(this.dom.menu, { opacity: 0, pointerEvents: 'none' });
    gsap.set(this.dom.menuItems, { opacity: 0, y: 24 });

    this.isOpen = false;
    this.isAnimating = false;
    this.dom.trigger.setAttribute('aria-expanded', false);
    this.dom.menu.setAttribute('aria-hidden', true);
    this.scrollEnable();
    document.body.removeAttribute('data-menu');
  }

	scrollDisable() {
    document.body.dataset.scroll = 'disabled';
	}

	scrollEnable() {
    document.body.removeAttribute('data-scroll');
	}

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      return;
    } else {
      if (this.isOpen) {
        this.resetMenu();
      }
      return;
		}
	}
}

export default Hamburger